import { Component, Input, OnInit } from '@angular/core';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ShiveDialogService } from '../../../../../../core/services/controls/shive-dialog.service';
import { UserOperation } from '../../../../../../core/enums/user-operation';
import { ExpenditureEntryService } from '../../manage-project/project-calculation-form/services/expenditure-entry.service';
import { ProjectDataService } from '../../../state-and-data-handling/project-data.service';
import { ExpenditureRateEntry } from '../../../../../../core/models/project/project-expenditure-entry.model';

@Component({
  selector: 'app-expenditure-history-dialog',
  templateUrl: './expenditure-history-dialog.component.html',
  styleUrls: ['./expenditure-history-dialog.component.scss'],
  standalone: false,
})
export class ExpenditureHistoryDialogComponent implements OnInit {
  @Input() expenditureRateHistory: ExpenditureRateEntry[];
  public updateEnabled = false;
  public expenditureHistoryForm: FormGroup;
  protected readonly faPenToSquare = faPenToSquare;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly shiveDialogService: ShiveDialogService,
    private readonly expenditureEntryService: ExpenditureEntryService,
    private readonly projectDataService: ProjectDataService,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  public close(): void {
    this.shiveDialogService.close(UserOperation.Cancel);
  }

  public submit(): void {
    const billableValue = +this.expenditureHistoryForm.controls.newHourlyRate.value;

    if (this.expenditureHistoryForm.controls.applyHourlyRateTo.value === 'all') {
      this.expenditureRateHistory = [
        this.expenditureEntryService.createExpenditureEntry(
          billableValue,
          this.projectDataService.getProjectClone().startsAt,
          0,
        ),
      ];
    } else {
      // 'custom'
      const startingFrom = this.expenditureHistoryForm.controls.dateFrom.value;
      const newExpenditureEntry: ExpenditureRateEntry =
        this.expenditureEntryService.createExpenditureEntry(
          billableValue,
          startingFrom,
          this.expenditureRateHistory.length,
        );

      this.expenditureRateHistory = this.expenditureEntryService.alignExpenditureEntriesByDateFrom(
        newExpenditureEntry,
        this.expenditureRateHistory,
      );
    }
    this.shiveDialogService.close(this.expenditureRateHistory);
  }

  public buttonChanged(): void {
    if (this.expenditureHistoryForm.controls.applyHourlyRateTo.value === 'custom') {
      this.expenditureHistoryForm.controls.dateFrom.disable();
    } else {
      this.expenditureHistoryForm.controls.dateFrom.enable();
    }
  }

  public inputValueChanged(newValue: unknown): void {
    this.updateEnabled = newValue !== null;
  }

  private initForm(): void {
    this.expenditureHistoryForm = this.formBuilder.group({
      newHourlyRate: [],
      applyHourlyRateTo: ['all'],
      dateFrom: [{ value: new Date(), disabled: true }],
    });
  }
}
